import React from 'react'
import { Skeleton, Box } from '@mui/material';
const ListingSkeleton = ({ listLength = 10 }) => {
    return (
        <Box sx={{ flexGrow: 1, padding: 2 }}>
            {/* Table */}
            <Box>
                {Array.from({ length: listLength })?.map((_, index) => (
                    <Skeleton key={index} variant="text" width="100%" height={70} />
                ))}
            </Box>
        </Box>
    )
}

export default ListingSkeleton